class FormattedPhoneNumber {
    public FormattedPhoneNumber: string;
    public ContactType: string;
    public PhoneType: string;
}

export { FormattedPhoneNumber };
